import $ from 'jquery';
import notify from '../notify';

export default function() {
    let delay = 0;
    $('[data-notify]', this).each(function () {
        const $this = $(this);
        const type = $this.attr('data-notify') || 'success';
        const fn = notify[type];
        const content = $this.html();
        if(typeof fn === 'function') {
            setTimeout(() => fn(content), delay);
            delay += 100;
        }
    });
};




// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/notify.js